module.exports = __webpack_public_path__ + "static/headphones-reviews-slider-section-code-02a4b98a7099e71813b85baea47b2411.png";